import { UserRoundCheck } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export function TeamHeadcountWidget() {
  return (
    <Card>
      <CardHeader className='flex flex-row items-center justify-between pb-2'>
        <CardTitle className='text-sm font-medium text-muted-foreground'>
          Team Headcount
        </CardTitle>
        <UserRoundCheck className='h-4 w-4 text-muted-foreground' />
      </CardHeader>
      <CardContent>
        <div className='text-3xl font-bold text-foreground'>57</div>
        <p className='text-xs text-muted-foreground mt-1'>
          Dummy data — live connection coming later
        </p>
      </CardContent>
    </Card>
  )
}
